export const theme = {
  colors: {
    primary: "#034EA2",
    primaryDark: "#023570",
    primaryLight: "#E6EEF8",
    accent: "#F15A22",
    accentHover: "#D14E1C",
    text: "#1A2B3C",
    textSecondary: "#5A6B7D",
    textMuted: "#8A9BAB",
    background: "#FFFFFF",
    backgroundAlt: "#F5F7FA",
    backgroundDark: "#022A52",
    border: "#E2E8F0",
    white: "#FFFFFF",
  },
  shadows: {
    sm: "0 1px 3px rgba(2, 42, 82, 0.08)",
    md: "0 4px 16px rgba(2, 42, 82, 0.1)",
    lg: "0 12px 32px rgba(2, 42, 82, 0.12)",
  },
  radius: {
    sm: "6px",
    md: "12px",
    lg: "16px",
    full: "9999px",
  },
};
